import { doc, getDoc } from "firebase/firestore";
import { auth, db } from "../firebase";

export async function hasPermission(permission, permissions) {
    if (permissions !== null && permissions !== undefined) {
        return permissions.includes(permission) || permissions.includes('admin') !== null;
    } else {
        console.log(auth.currentUser);
        const user = await getDoc(doc(db, 'admins', auth.currentUser?.uid??''));
        const userPermissions = user.data()?.permisions??{};

        return userPermissions[permission] !== null || userPermissions['admin'] !== null;
    }
}

export async function getPermissions() {
    const retVal = [];

    const user = await getDoc(doc(db, 'admins', auth.currentUser?.uid??''));
    if (user.exists()) {
        console.log(user.get('permisions'));
        Object.keys(user.get('permisions')??{}).forEach(key => {
            retVal.push(key);
        });
    }

    return retVal;
}